import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async request => {
  try {
    const response = await tuApptoAPI.post('/votings/findall', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/votings/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async id => {
  try {
    const response = await tuApptoAPI.delete(`/votings/delete/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const findAllDetail = async request => {
  try {
    const response = await tuApptoAPI.post('/votings/details/findall', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const createDetail = async request => {
  try {
    const response = await tuApptoAPI.post('/votings/details/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const updateDetail = async request => {
  try {
    const response = await tuApptoAPI.put('/votings/details/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const removeDetail = async id => {
  try {
    const response = await tuApptoAPI.delete(`/votings/resolutions/delete/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const changeStatus = async request => {
  try {
    const response = await tuApptoAPI.put('/votings/status/update', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
